<template>
    <div class="page-container pt-5" style="scroll-behavior: smooth;">
        <div class="page-paddings-left text-white">
            <b-row>
                <b-col cols="12 mt-5">
                    <h1 class="entry-tittle-main">Datenschutz auf einen Blick </h1>
                    <br>
                </b-col>
            </b-row>

            <b-row>
                <b-col>

                    <h2> 1 Allgemeine Informationen</h2>
                    <p>
                        Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten geschieht, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, die Sie persönlich identifizieren. Ausführliche Informationen zum Thema Datenschutz finden Sie in unserer unter diesem Text aufgeführten Datenschutzerklärung. <br>
                        Datenerhebung auf unserer Website <br>
                    </p>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <p>
                        <strong>Wer ist für die Datenerhebung auf dieser Website verantwortlich?</strong><br>
                        Die Datenverarbeitung auf dieser Website erfolgt durch den Betreiber der Website. Kontaktdaten finden Sie im Impressum dieser Website.
                        <br>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>
                        <strong>Wie erheben wir Ihre Daten? </strong><br>
                        Zum einen werden Ihre Daten von Ihnen erhoben, indem Sie sie uns mitteilen. Dies können z.B. Daten sein, die Sie in einem Kontaktformular eingeben.
                        <br>
                        Weitere Daten werden von unseren IT-Systemen automatisch erhoben, wenn Sie die Website besuchen. Dies sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Zeitpunkt des Seitenaufrufs). Diese Daten werden automatisch erhoben, sobald Sie unsere Website besuchen.
                        <br>

                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>
                        <strong>Wofür verwenden wir Ihre Daten?</strong><br>
                        Ein Teil der Daten wird gesammelt, um sicherzustellen, dass die Website fehlerfrei ist. Weitere Daten können verwendet werden, um Ihr Nutzerverhalten zu analysieren.
                        <br>
                    </p>
                </b-col>
            </b-row>

            <b-row><b-col><p><strong>Welche Rechte haben Sie in Bezug auf Ihre Daten? </strong>
                <br>Sie haben das Recht, jederzeit und kostenlos Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben auch das Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierfür sowie für weitere Fragen zum Thema Datenschutz stehen wir Ihnen unter der im Impressum angegebenen Adresse jederzeit zur Verfügung. Darüber hinaus haben Sie das Recht, sich an die zuständige Aufsichtsbehörde zu wenden.<br>
            </p></b-col>
            </b-row>

            <b-row>
                <b-col>
                    <p>

                        <strong>Haftung für Inhalte </strong><br>
                        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. <br>
                        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen. <br>

                    </p>
                </b-col>
            </b-row>


            <b-row>
                <b-col>

                    <h2>2. Allgemeine Informationen und Pflichtangaben </h2>

                    <strong> </strong><br>
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. <br>
                    Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen. <br>

                </b-col>
            </b-row>


            <b-row>
                <b-col>
                    <p>
                        <strong>Datenschutzerklärung</strong><br>
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und gemäß den gesetzlichen Datenschutzbestimmungen sowie dieser Datenschutzerklärung. <br>
                        Wenn Sie diese Website nutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Diese Datenschutzerklärung erläutert, welche Informationen wir sammeln und wie wir sie verwenden. Es wird auch erklärt, wie und zu welchem Zweck dies geschieht. <br>
                        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. <br>
                        Hinweis auf die zuständige Stelle <br>
                    </p>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <p>
                        <strong>NORTH IT GROUP GmbH </strong><br>
                        NORTH IT GROUP GmbH <br>
                        Vertreten durch Stephan Hoffmann<br>
                    </p>
                </b-col>
            </b-row>


            <b-row>
                <b-col>
                    <p>
                        Auch beim Auskunftsrecht (Art. 15 DSGVO), dem Recht auf Berichtigung (Art. 16 DSGVO) und dem Recht auf Löschung (Art. 17 DSGVO) unterstützt Sie der Datenschutzbeauftragte.

                        Bei Auskünften gemäß Art. 15 DSGVO behalten wir uns vor, vorab Ihre Identität zu prüfen, damit Ihre personenbezogenen Daten nicht unberechtigten Personen bekannt werden. <br>
                        Bitte nehmen Sie hierzu auch den Abschnitt "Ihre Rechte als betroffene Person" weiter unten in diesem Dokument zur Kenntnis. <br>
                        Was sind personenbezogene Daten und welche personenbezogenen Daten werden von uns erfasst?

                        Personenbezogene Daten sind Daten, die Rückschlüsse auf die Identität einer Person zulassen.

                        Auch der Browser des Betroffenen übermittelt bestimmte personenbezogene Daten (siehe Unterabschnitt "Übermittlung technischer Daten"). <br>
                        Diese Daten werden in Logdateien gespeichert. Rechtsgrundlage für diese Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f DSGVO. Die Daten werden nach sechs Wochen (siehe Abschnitt "Speicherdauer und Löschung") gelöscht. <br>
                        Personenbezogene Daten werden von uns nur dann aktiv verarbeitet, wenn der Nutzer freiwillig in die Nutzung seiner Daten einwilligt. Dies ist nach einer entsprechenden Einwilligung in die Nutzung von Statistik-Cookies der Fall, die dann von Google Analytics verarbeitet werden (siehe weiter unten). <br>
                        Auch das Versenden von Kontaktformularen und das Abonnement des Newsletters setzt eine Einwilligung des Betroffenen (Art. 6 Abs. 1 lit. a DSGVO ) voraus.

                        Zwecke und Rechtsgrundlagen der Datenverarbeitung

                        Allgemeines zur Rechtsgrundlage <br>
                        Soweit (Formulare, Newsletteranmeldung) für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage. <br>
                        Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind. <br>
                        Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage. <br>
                        Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung. <br>
                        Besuch der Website

                        Sie können unsere Website besuchen ohne Angaben zu Ihrer Person zu machen. Es werden lediglich vom Browser Daten übermittelt (siehe weiter unten). <br>
                        Falls Sie beim erstmaligen Besuch unserer Website nicht in die Nutzung von Cookies einwilligen, werden keine verwendet, ansonsten die von Ihnen gewählte Kategorie von Cookies.

                        Hosting, Übermittlung technischer Daten <br>
                        Unsere Website wird bei einem externen Dienstleister gehostet. Wir haben mit dem Hoster eine Vereinbarung zur Auftragverarbeitung gemäß Art. 28 DSGVO abgeschlossen. Nehmen Sie hierzu bitte den Abschnitt "Auftragsverarbeiter" weiter unten in diesem Dokument zur Kenntnis. <br>
                        Beim Aufruf unserer Website übermittelt Ihr Browser Daten an den Server des Hostingdienstleisters.

                        Auf den Inhalt dieser Übermittlung haben wir keinen Einfluss. Es handelt sich um folgende Daten: <br>
                    </p>
                    <ul>
                        <li>Host (Internet Service Provider, Unternehmen) </li>
                        <li>Browsertyp und die verwendete Version des Browsers </li>
                        <li>Betriebssystem des Nutzers </li>
                        <li>Die IP-Adresse des Nutzers </li>
                        <li>das verwendete Protokoll (http, https) </li>
                        <li>Datum und Uhrzeit des Zugriffs </li>
                        <li>ggf. Fehlermeldungen </li>
                        <li>"Referrer-URL", also die Website, von der aus auf unsere Website verbunden wurde. </li>
                        <li>die angeforderte Seite unserer Website </li>
                    </ul>
                    <p>
                        Datenlöschung und Speicherdauer <br>
                        Grundsätzlich werden personenbezogenen Daten der betroffenen Person gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. <br>
                        Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde. <br>
                        Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht. <br>
                        Ihre Rechte als betroffene Person<br>
                        Die DSGVO garantiert Ihnen Rechte an Ihren Daten und Möglichkeiten, diese durchzusetzen. Im folgenden zählen wir diese Rechte auf und zitieren den Wortlaut des entsprechenden Absatzes in der DSGVO. <br>
                        Auskunftsrecht (Art. 15 DSGVO)<br>
                        "Die betroffene Person hat das Recht, von dem Verantwortlichen eine Bestätigung darüber zu verlangen, ob sie betreffende personenbezogene Daten verarbeitet werden; ist dies der Fall, so hat sie ein Recht auf Auskunft über diese personenbezogenen Daten und auf folgende Informationen: <br>
                    </p>
                    <ul>
                        <li>die Verarbeitungszwecke; </li>
                        <li>die Kategorien personenbezogener Daten, die verarbeitet werden; </li>
                        <li>die Empfänger oder Kategorien von Empfängern, gegenüber denen die personenbezogenen Daten offengelegt worden sind oder noch offengelegt werden, insbesondere bei Empfängern in Drittländern oder bei internationalen Organisationen; </li>
                        <li>falls möglich die geplante Dauer, für die die personenbezogenen Daten gespeichert werden, oder, falls dies nicht möglich ist, die Kriterien für die Festlegung dieser Dauer; das Bestehen eines Rechts auf Berichtigung oder Löschung der sie betreffenden personenbezogenen Daten oder auf Einschränkung der Verarbeitung durch den Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung; </li>
                        <li>das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde; wenn die personenbezogenen Daten nicht bei der betroffenen Person erhoben werden, alle verfügbaren Informationen über die Herkunft der Daten; </li>
                        <li>das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling gemäß Artikel 22 Absätze 1 und 4 und – zumindest in diesen Fällen – aussagekräftige Informationen über die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung für die betroffene Person." </li>
                    </ul>
                    <p>
                        Recht auf Berichtigung (Art. 16 DSGVO) <br>
                        "Die betroffene Person hat das Recht, von dem Verantwortlichen unverzüglich die Berichtigung sie betreffender unrichtiger personenbezogener Daten zu verlangen. 2Unter Berücksichtigung der Zwecke der Verarbeitung hat die betroffene Person das Recht, die Vervollständigung unvollständiger personenbezogener Daten – auch mittels einer ergänzenden Erklärung – zu verlangen."

                        Recht auf Löschung (Art. 17 DSGVO) <br>
                        Sie haben das Recht, von uns die Löschung Ihrer personenbezogenen Daten zu verlangen. Wir löschen Ihre Daten, solange dem keine andere gesetzlichen Verpflichtungen entgegegenstehen.

                        " Die betroffene Person hat das Recht, von dem Verantwortlichen zu verlangen, dass sie betreffende personenbezogene Daten unverzüglich gelöscht werden, und der Verantwortliche ist verpflichtet, personenbezogene Daten unverzüglich zu löschen, sofern einer der folgenden Gründe zutrifft: <br>

                    </p>

                    <ul>
                        <li>Die personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.</li>
                        <li>Die betroffene Person widerruft ihre Einwilligung, auf die sich die Verarbeitung gemäßArtikel6Absatz 1 Buchstabe a oderArtikel 9Absatz 2 Buchstabe a stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.</li><li>Die betroffene Person legt gemäßArtikel 21Absatz 1 Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder die betroffene Person legt gemäßArtikel 21Absatz 2 Widerspruch gegen die Verarbeitung ein.</li>
                        <li>Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>
                        <li>Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.</li>
                        <li>Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäßArtikel 8Absatz 1 erhoben."</li>
                    </ul>
                    <p>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)<br>
                        "Die betroffene Person hat das Recht, von dem Verantwortlichen die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:<br></p>

                    <ul>
                        <li>die Richtigkeit der personenbezogenen Daten von der betroffenen Person bestritten wird, und zwar für eine Dauer, die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen,</li>
                        <li>die Verarbeitung unrechtmäßig ist und die betroffene Person die Löschung der personenbezogenen Daten ablehnt und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangt;</li>
                        <li>der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigt, die betroffene Person sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigt, oder</li>
                        <li>die betroffene Person Widerspruch gegen die Verarbeitung gemäß Artikel 21 Absatz 1 eingelegt hat, solange noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person überwiegen.</li>
                    </ul>
                    <p>
                        Wurde die Verarbeitung gemäß Absatz 1 eingeschränkt, so dürfen diese personenbezogenen Daten – von ihrer Speicherung abgesehen – nur mit Einwilligung der betroffenen Person oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Union oder eines Mitgliedstaats verarbeitet werden." <br>
                        Recht auf Unterrichtung (Art. 19 DSGVO)  <br>
                        "Der Verantwortliche teilt allen Empfängern, denen personenbezogenen Daten offengelegt wurden, jede Berichtigung oder Löschung der personenbezogenen Daten oder eine Einschränkung der Verarbeitung nach Artikel 16, Artikel 17 Absatz 1 und Artikel 18 mit, es sei denn, dies erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand verbunden.  <br>
                        Der Verantwortliche unterrichtet die betroffene Person über diese Empfänger, wenn die betroffene Person dies verlangt."  <br>
                        Recht auf Datenübertragbarkeit (Art. 20 DSGVO) <br>
                        "Die betroffene Person hat das Recht, die sie betreffenden personenbezogenen Daten, die sie einem Verantwortlichen bereitgestellt hat, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten, und sie hat das Recht, diese Daten einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt wurden, zu übermitteln, sofern <br>
                    </p>

                    <ul>
                        <li>die Verarbeitung auf einer Einwilligung gemäß Artikel 6 Absatz 1 Buchstabe a oder Artikel 9 Absatz 2 Buchstabe a oder auf einem Vertrag gemäß Artikel 6 Absatz 1 Buchstabe b beruht und </li>
                        <li>die Verarbeitung mithilfe automatisierter Verfahren erfolgt. </li>
                    </ul>

                    <p>Bei der Ausübung ihres Rechts auf Datenübertragbarkeit gemäß Absatz 1 hat die betroffene Person das Recht, zu erwirken, dass die personenbezogenen Daten direkt von einem Verantwortlichen einem anderen Verantwortlichen übermittelt werden, soweit dies technisch machbar ist.<br>
                        Die Ausübung des Rechts nach Absatz 1 des vorliegenden Artikels lässt Artikel 17 unberührt. Dieses Recht gilt nicht für eine Verarbeitung, die für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde.<br>
                        Das Recht gemäß Absatz 1 darf die Rechte und Freiheiten anderer Personen nicht beeinträchtigen."<br>Widerspruchsrecht (Art. 21 DSGVO)
                    </p>
                    <ul>
                        <li>Die betroffene Person hat das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung sie betreffender personenbezogener Daten, die aufgrund vonArtikel 6Absatz 1 Buchstaben e oder f erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Der Verantwortliche verarbeitet die personenbezogenen Daten nicht mehr, es sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die die Interessen, Rechte und Freiheiten der betroffenen Person überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen. </li>
                        <li>Werden personenbezogene Daten verarbeitet, um Direktwerbung zu betreiben, so hat die betroffene Person das Recht, jederzeit Widerspruch gegen die Verarbeitung sie betreffender personenbezogener Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.</li>
                        <li>Widerspricht die betroffene Person der Verarbeitung für Zwecke der Direktwerbung, so werden die personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet.</li>
                        <li>Die betroffene Person muss spätestens zum Zeitpunkt der ersten Kommunikation mit ihr ausdrücklich auf das in den Absätzen 1 und 2 genannte Recht hingewiesen werden; dieser Hinweis hat in einer verständlichen und von anderen Informationen getrennten Form zu erfolgen.</li>
                        <li>Im Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft kann die betroffene Person ungeachtet derRichtlinie 2002/58/EGihr Widerspruchsrecht mittels automatisierter Verfahren ausüben, bei denen technische Spezifikationen verwendet werden.</li>
                        <li>Die betroffene Person hat das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, gegen die sie betreffende Verarbeitung sie betreffender personenbezogener Daten, die zu wissenschaftlichen oder historischen Forschungszwecken oder zu statistischen Zwecken gemäßArtikel 89Absatz 1 erfolgt, Widerspruch einzulegen, es sei denn, die Verarbeitung ist zur Erfüllung einer im öffentlichen Interesse liegenden Aufgabe erforderlich."</li>
                    </ul><p>Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung (Art. 7 DSGVO Abs. 3) "Die betroffene Person hat das Recht, ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt. Die betroffene Person wird vor Abgabe der Einwilligung hiervon in Kenntnis gesetzt. Der Widerruf der Einwilligung muss so einfach wie die Erteilung der Einwilligung sein."<br>Recht auf Beschwerde bei einer Aufsichtsbehörde (Art.77 Abs.1 DSGVO)<br>"Jede betroffene Person hat unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, wenn die betroffene Person der Ansicht ist, dass die Verarbeitung der sie betreffenden personenbezogenen Daten gegen diese Verordnung verstößt."<br></p>
                    <p>
                        <strong>Landesbeauftragter für den Datenschutz Sachsen-Anhalt </strong>
                        Dr. Harald von Bose <br>
                        Leiterstraße 9, 39104 Magdeburg
                        Postfach 1947, 39009 Magdeburg  <br>
                        Telefon: +49 391 81803-0
                        Telefax: +49 391 81803-33<br>
                        E-Mail:poststelle(at)lfd.sachsen-anhalt.de.<br>
                        Links zu anderen Websites<br>
                        Diese Webseite beinhaltet Verlinkungen zu Webseiten Dritter - sog. externe Links. Die Inhalte dieser externen Links entziehen sich unserer Einflussnahme, sodass eine Gewähr für solche Inhalte unsererseits nicht übernommen wird. Die Verantwortung liegt stets beim jeweiligen Betreiber der externen Seiten. Zum Zeitpunkt der Verknüpfung der externen Links waren keine Rechtsverstöße ersichtlich. Die permanente Überwachung fremder Inhalte auf Rechtsverstöße ohne konkrete Hinweise ist uns nicht zumutbar. Sollten wir Kenntnis von Rechtsverletzungen erlangen, werden wir die entsprechenden externen Links unverzüglich entfernen. <br>
                        Sicherheit<br>
                        Wir treffen technische und organisatorische Sicherheitsvorkehrungen, um Ihre durch uns verwalteten personenbezogenen Daten gegen zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Unsere Datenverarbeitung und unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert. Bei der Übertragung Ihrer personenbezogenen Daten an uns wird eine Verschlüsselung durch Secure Socket Layer (SSL) vorgenommen. <br><br>
                        Unsere Mitarbeiter sind selbstverständlich auf das Datengeheimnis verpflichtet.
                        Auftragsverarbeiter<br>
                        Einige Dienste auf unserer Website werden mit Hilfe von Dienstleistern zur Verfügung gestellt. Es handelt sich um Dienste in den Bereichen<br>

                    </p>
                    <ul>
                        <li>Hosting </li>
                        <li>Newsletteranmeldung, Newslettermanagement</li>
                        <li>Webanalyse, Tracking </li>
                        <li>Bewertungsmanagement </li>
                    </ul>
                    <p>
                        Mit den entsprechenden Unternehmen haben wir Vereinbarungen zur Auftragsverarbeitung gemäß Art. 28 DSGVO abgeschlossen und geben im Anschluss die Datenschutzerklärungen dieser Unternehemen wieder.
                    </p>
                    <p>
                        Hosting<br>
                        Wir hosten selbst.<br>
                        Newsletter<br>
                        MailChimp<br>
                    </p>
                    <p>
                        Der Versand unsers Newsletters erfolgt mittels "MailChimp", einer Newsletterversandplattform des US-Anbieters Rocket Science Group, LLC, 675 Ponce De Leon Ave NE #5000, Atlanta, GA 30308, USA. Die E-Mail-Adressen unserer Newsletterempfänger, als auch weitere, im Rahmen dieser Hinweise beschriebenen Daten, werden auf den Servern von MailChimp in den USA gespeichert. MailChimp verwendet diese Informationen zum Versand und zur Auswertung der Newsletter in unserem Auftrag. Des Weiteren kann MailChimp nach eigenen Informationen diese Daten zur Optimierung oder Verbesserung der eigenen Services nutzen, z.B. zur technischen Optimierung des Versandes und der Darstellung der Newsletter oder für wirtschaftliche Zwecke, um zu bestimmen aus welchen Ländern die Empfänger kommen. MailChimp nutzt die Daten unserer Newsletterempfänger jedoch nicht, um diese selbst anzuschreiben oder an Dritte weiterzugeben. MailChimp ist unter dem US-EU-Datenschutzabkommen „Privacy Shield“ zertifiziert und verpflichtet sich damit die EU-Datenschutzvorgaben einzuhalten. Des Weiteren haben wir mit MailChimp ein „Data-Processing-Agreement“ abgeschlossen. Dabei handelt es sich um einen Vertrag, in dem sich MailChimp dazu verpflichtet, die Daten unserer Nutzer zu schützen, entsprechend dessen Datenschutzbestimmungen in unserem Auftrag zu verarbeiten und insbesondere nicht an Dritte weiter zu geben.

                        <br><a href="https://mailchimp.com/legal/data-processing-addendum/">Auftragsverarbeitungsvereinbarung Mailchimp</a>

                        <br> <a href="https://mailchimp.com/legal/privacy/">Datenschutzerklärung Mailchimp</a>

                        <br>Tracking

                        <br>  Google Analytics und Google Tag Manager
                        <br>
                        Unsere Webseite nutzt die Dienste von Google Analytics. Dabei handelt es ich um einen Webanalysedienst der Google Inc. Die Analyse der Benutzung der Webseite durch Sie wird dadurch ermöglicht, dass sog. "Cookies" auf Ihrem Computer gespeichert werden und diese dann Informationen über Ihr Benutzungsverhalten generieren und an Google Inc. weiterleiten. In der Regel wird eine gekürzte Version Ihrer IP-Adresse an Google Server weitergeleitet. In Ausnahmefällen kann auch die komplette IP-Adresse weitergeleitet werden. Diese Informationen nutzt Google in unserem Auftrag zur Erstellung eines Reports über das Benutzerverhalten auf unseren Seiten. Die durch Google Analytics ermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Sollten Sie keine Speicherung von Cookies auf Ihrem Computer wünschen, so können Sie entsprechende Einstellungen in Ihrem Browser vornehmen. Leider kann dies eine eingeschränkte Nutzung unserer Seiten zur Folge haben.Sie können die Erfassung durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, das die zukünftige Erfassung Ihrer Daten beim Besuch dieser Website verhindert: Google Analytics deaktivieren Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter<a href="http://www.google.com/analytics/terms/de.html">link</a>bzw. unter<a href="https://www.google.de/intl/de/policies/">https://www.google.de/intl/de/policies/</a>. Wir weisen Sie darauf hin, dass auf dieser Website Google Analytics um den Code „anonymizeIp” erweitert wurde, um eine anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu gewährleisten. <a href="http://www.google.com/settings/ads/onweb/?hl=de">link</a>
                    </p>
                    <p>
                        Wir verwenden zusätzlich den Google Tag Manager. Mit diesem Dienst können Website-Tags verwaltet werden. Der Google Tag Manager richtet lediglich Tags ein - bei Tags handelt es sich um Code, der dazu verwendet wird, Besucheraufkommen und Besucherverhalten zumessen. Die Tags stammen von anderen Diensten - in unserem Fall von Google Analytics (siehe weiter onben). Über den Google Tag Manager werden diese Tags lediglich verwaltet, es werden keine Cookies gesetzt und es erfolgt auch keine Erfasssung personenbezogener Daten. Wenn eine Deaktivierung des Trackings vorgenommen wurde, so gilt das auch für alle Tracking-Tags, die mit dem Google Tag Manager verwaltet werden.
                        <br> Google reCAPTCHA
                    </p>
                    <p>Um für ausreichend Datensicherheit bei der Übermittlung von Formularen Sorge zu tragen, verwenden wir in bestimmten Fällen den Service reCAPTCHA des Unternehmens Google Inc. Dies dient vor allem zur Unterscheidung, ob die Eingabe durch eine natürliche Person erfolgt oder missbräuchlich durch maschinelle und automatisierte Verarbeitung. Der Service inkludiert den Versand der IP-Adresse und ggf. weiterer von Google für den Dienst reCAPTCHA benötigter Daten an Google ein. Hierfür gelten die abweichenden Datenschutzbestimmungen von Google Inc. Weitere Informationen zu den Datenschutzrichtlinien von Google Inc. finden Sie unter<a href="www.google.de/intl/de/privacy">www.google.de/intl/de/privacy</a>oder<a href="www.google.com/intl/de/policies/privacy/">link</a>
                    </p>
                    <h2>Cookie policy</h2>
                    <strong>_ga</strong>
                    <p>Dieses Cookie wird von Google Analytics installiert. Das Cookie wird verwendet, um Besucher-, Sitzungs- und Kampagnendaten zu berechnen und die Nutzung der Website für den Analysebericht der Website zu verfolgen. Die Cookies speichern Informationen anonym und weisen eine zufällig generierte Nummer zu, um eindeutige Besucher zu identifizieren. 2 years Analytics</p>
                    <strong>_gid</strong>
                    <p>Dieses Cookie wird von Google Analytics installiert. Das Cookie wird verwendet, um Informationen darüber zu speichern, wie Besucher eine Website nutzen, und hilft bei der Erstellung eines Analyseberichts über den Zustand der Website. Die gesammelten Daten, einschließlich der Anzahl der Besucher, der Quelle, aus der sie gekommen sind, und der Seiten, die in anonymisierter Form besucht wurden. 1 day Analytics</p>
                    <strong>_gat</strong>
                    <p>Diese Cookies werden von Google Universal Analytics installiert, um die Anforderungsrate zu drosseln und so die Sammlung von Daten auf stark frequentierten Websites einzuschränken. 1 minute Performance</p>
                    <strong>_gat_gtag_UA_161769463_1</strong>
                    <p>Google verwendet dieses Cookie zur Unterscheidung der Nutzer. 1 minute Analytics</p>


                    <template>
                            <h2 class="mt-5">Ihre Google Analytics- und Cookie-Einstellungen aktualisieren </h2>
                            <div>

                                <b-form-group>
                                <b-form-checkbox v-model="selected" @change="activateDeactivateGA" name="check-button" switch>
                                   {{ selected ? 'Google analytics aktivieren' : 'Google analytics deaktivieren'}}
                                </b-form-checkbox>
                                </b-form-group>

                                <b-form-group>
                                    <b-form-checkbox v-model="selected2" @change="activateDeactivateCookie" name="check-button" switch>
                                        {{ selected2 ? 'Cookie aktivieren' : 'Cookie deaktivieren'}}
                                    </b-form-checkbox>
                                </b-form-group>

                            </div>
                    </template>
                </b-col>
            </b-row>
            <b-row class="entry-part-end text-left">
                <b-button @click="$router.push('/')" class="cc-button text-center mx-auto">Back</b-button>
            </b-row>
        </div>

        <b-row class="site-footer">
            <b-col class="col-12"><p class="text-center pt-3 pr-4"><router-link to="/Impressum">Impressum</router-link></p></b-col>
        </b-row>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                selected: localStorage.getItem('GA'),
                selected2: localStorage.getItem('COOKIE'),
            }
        },
        methods: {
            activateDeactivateGA() {
                localStorage.setItem('GA', !this.selected);
                if(this.selected) {
                    this.$ga.enable();
                    return;
                }
                this.$ga.disable();
            },
            activateDeactivateCookie() {
                localStorage.setItem('COOKIE', !this.selected2);
                if(this.selected2) {
                    this.$cookies.set('_accepted', true);
                    return;
                }
                this.$cookies.remove('_accepted');
            }
        }
    }
</script>

<style>
    html {
        scroll-behavior: smooth;
    }
    body {
        font-family: Poppins!important;
        scroll-behavior: smooth;
    }
    p {
        color: white;
    }
    .cc-intro {
        padding-top: 10%;
        display: inline-block;
        vertical-align: middle;
    }
    legend {
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        color: #FFFFFF!important;
    }
    .page-container {

        background-color: #474747;
    }
    .page-paddings {
        padding-left: 15%;
        padding-right: 15%;
    }
    .page-paddings-left {
        padding-left: 15%;
    }

    .cc-button {
        background: #00FBAF!important;
        box-shadow: -10px -10px 25px rgba(0, 251, 175, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
        padding-right: 25px!important;
        padding-left: 25px!important;
        border-radius: 50px!important;
        font-family: Poppins;
        font-style: normal;
        font-weight: 700!important;
        font-size: 24px;
        line-height: 133%;
        color: #474747!important;
    }
    .entry-tittle-main {
        width: 100%;
        background: linear-gradient( 90deg, #3079FF, #00FBAF);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: #0B2349;
        font-size: 4rem;
    }
    .cc-point-title {
        width: 100%;
        background: linear-gradient( 90deg, #3079FF, #00FBAF);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: #0B2349;
    }
    .cc-point-title-last {
        background: linear-gradient( 270deg, #3079FF, #00FBAF);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: #0B2349;
    }

    .row {
        margin-left: 0!important;
        margin-right: 0!important;
    }
    span {
        color: white;
    }
    .point-number {
        font-size: 28px;
        line-height: 133%;
        color: #3079FF;
    }

    .point-container {
        padding-top: 10px;
        padding-bottom: 35px;
    }
    .point-name {
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 133%;
        color: #FFFFFF;
        padding-top: 4px;
        padding-left: 10px;
    }

    .cc-questions-container {
        box-shadow: -10px -10px 25px rgba(255, 255, 255, 0.09), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
        border-radius: 45px;
        padding: 5%;
        margin-top: 3%;
        margin-bottom: 8%;
    }

    .amount-text {
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 133%;
        color: #FFFFFF;
        vertical-align: middle;
    }

    .amount-button {
        background: #474747!important;
        box-shadow: -10px -10px 25px rgba(255, 255, 255, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
        border-radius: 50px!important;
        width: 200px;
        font-family: Poppins;
        font-style: normal;
        font-weight:600!important;
        font-size: 24px!important;
        line-height: 132%;
        color: #00FBAF!important;
    }
    .amount-row {
        display: inline-flex;
    }
    hr {
        background: linear-gradient( 90deg, #3079FF, #00FBAF)!important;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        height: 1px!important;
    }
    .semi-final-amount {
        font-family: Poppins;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 133%;
        color: #FFFFFF;
    }
    .marketing-component {
        box-shadow: -10px -10px 25px rgba(0, 251, 175, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
        border-radius: 45px;
    }
    .site-footer {
        background: #323232;
        padding: 20px;
        margin-top: 50px;
    }

    .my-buttons .active {
        color: #fff !important;
        background-color: #28a745 !important;
        border-color: #28a745 !important;
    }
    input {
        /*background: linear-gradient( 90deg, #3079FF, #00FBAF)!important;*/
    }
    .d-grid {
        display: grid!important;
        padding-left: 33px;
    }

    .d-grid-40 {
        display: grid!important;
        padding-left: 40px;
    }
    .input-pad {
        padding-left: 17px;
    }

    .input-pad-big {
        padding-left: 25px;
    }
    input {
        background-color: #474747;
        /*border: #adb5bd solid 1px;*/
        box-shadow: inset 0px 4px 15px rgba(0, 0, 0, 0.4) !important;
        border: none!important;
        color: white!important;
    }

    .custom-control-label::before {
        position: absolute;
        top: 0.25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        pointer-events: none;
        content: "";
        background: #474747!important;
        box-shadow: inset 0px 4px 15px rgba(0, 0, 0, 0.4)!important;
        border: none!important;
    }

    .custom-control-label::after {
        position: absolute;
        top: 0.25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
        background: no-repeat 50% / 50% 50%;
    }

    .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
        background-image: url("../assets/chech.png") !important;
        width: 35px!important;
        height: 35px!important;
        left: -31px!important;
        top: -9px!important;
    }

    .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
        background-image: url("../assets/radio.png") !important;
    }

    .custom-range::-webkit-slider-thumb {
        background: transparent!important;
        background-color: transparent!important;
        width: 1rem!important;
        height: 1rem!important;
        margin-top: -0.25rem;
        background-image: url("../assets/radio.png") !important;
        border: 0;
        border-radius: 1rem;
        -webkit-transition: none!important;
        transition:none!important;
        -webkit-appearance: none;
        appearance: none;
    }
    .drop-highlighter {
        color: #00FBAF;
    }
    .drop-container {
        display: none;
    }
    .clickedb2b {
        display: block!important;
    }
    #range-2 {
        background-color: transparent!important;
        box-shadow: none !important;
    }
    .comment-info {
        display: inline-block;
        visibility: hidden;
        transition: visibility .3s ease-in-out;
        position: absolute;
        top: -50%;
        background: #474747;
        box-shadow: -15px -15px 35px rgba(255, 255, 255, 0.03), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;;
        border-radius: 30px;
        padding: 35px;
        width: 40vw;
        z-index: 200;
    }

    .comment-info.visible {
        visibility: visible;
    }

    .b-hover:hover {
        color: #00FBAF;
    }
    .form-control  {
        background: #474747!important;
    }

    .vue-slider-dot-tooltip-text {
        color: #00FBAF!important;
        font-size: 1.4rem!important;
    }

    @media screen and (max-width: 576px) {
        a {
            color: white!important;
        }

        html {
            scroll-behavior: smooth;
        }
        body {
            font-family: Poppins!important;
            scroll-behavior: smooth;
        }
        p {
            color: white;
        }
        .cc-intro {
            padding-top: 10%;
            display: inline-block;
            vertical-align: middle;
        }
        legend {
            font-family: Poppins;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            color: #FFFFFF!important;
        }
        .page-container {
            background-color: #474747;
        }
        .page-paddings {
            padding-left: 5%;
            padding-right: 5%;
        }
        .page-paddings-left {
            padding-left: 5%;
        }

        .entry-tittle-main {
            width: 100%;
            background: linear-gradient( 90deg, #3079FF, #00FBAF);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            color: #0B2349;
            font-size: 2.4rem;
            text-align: center;
            margin-top: -80px;
        }}

</style>